export function raf2x(fn) {
    window.requestAnimationFrame(() => window.requestAnimationFrame(fn));
}
//# sourceMappingURL=raf2x.js.map